export default __webpack_public_path__ + "static/media/wechat.62a035ee.svg";